<template>
    <v-card class="veggie-field fill-height">
        <v-container fluid>
            <v-layout column>
                <v-flex>
                    <v-slider v-model="userRows" thumb-label min="1" max="16" label="Rows" />
                    <v-slider v-model="userCols" thumb-label min="1" max="16" label="Columns" />
                </v-flex>
                <v-flex v-for="y in userRows" :key="y">
                    <v-layout row>
                        <v-flex v-for="x in userCols" :key="x">
                            <v-img :src="image" class="veggie" contain />
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        rows: {
            type: Number,
            required: true,
        },
        cols: {
            type: Number,
            required: true,
        },
    },
    data () {
        return {
            userRows: this.rows,
            userCols: this.cols,
        }
    },
    computed: {
        image () {
            return require(`../../assets/veggies/${this.type}.svg`)
        },
    },
}
</script>

<style >
.veggie-field.v-sheet {
    background: #cfaa5a;
}

.veggie-field .hill .flex {
    background: linear-gradient(to right,  transparent 0%,#c29a46 50%,transparent 100%);
}

.veggie {
    max-height: 3em;
}
</style>
